module.exports = __webpack_public_path__ + "static/media/han_vol.9f1b2c05.png";